import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiServices from '../Services/ApiServices';
import { toastHelper } from '../../Helpers/toastHelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faArrowRight, faUserPlus, faImage, faBook, faChalkboardTeacher, faSchool, faSearch } from '@fortawesome/free-solid-svg-icons';
import MiniLoader from '../Shared/MiniLoader';
import FileUploader from '../Shared/FileUploader';

const SeedData = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [userClasses, setUserClasses] = useState([]);
    const [materials, setMaterials] = useState([]);
    const [teachers, setTeachers] = useState([]);

    const [showTeacherResults, setShowTeacherResults] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedTeacher, setSelectedTeacher] = useState(null);

    const [formData, setFormData] = useState({
        material_id: '',
        user_class: '',
        number_of_students: 10,
        Image: null
    });
    const [previewImage, setPreviewImage] = useState(null);

    const teacherSearchRef = useRef(null);

    useEffect(() => {
        fetchUserClasses();
        fetchMaterials();
    }, []);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchTerm.trim().length > 0) {
                fetchTeachers(searchTerm);
            } else {
                setTeachers([]);
                setShowTeacherResults(false);
            }
        }, 300);
        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);

    // Handle outside click for teacher dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (teacherSearchRef.current && !teacherSearchRef.current.contains(event.target)) {
                setShowTeacherResults(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const fetchUserClasses = async () => {
        try {
            const response = await ApiServices.get('Lookup/UserClasses');
            if (response && response.data) {
                setUserClasses(response.data);
            } else if (Array.isArray(response)) {
                setUserClasses(response);
            }
        } catch (error) {
            
        }
    };

    const fetchMaterials = async () => {
        try {
            const response = await ApiServices.get('Lookup/Materials');
            if (response && response.data) {
                setMaterials(response.data);
            } else if (Array.isArray(response)) {
                setMaterials(response);
            }
        } catch (error) {
            
        }
    };

    const fetchTeachers = async (term) => {
        try {
            const response = await ApiServices.get(`Lookup/Teachers/filter?Name=${encodeURIComponent(term.trim())}`);
            if (response && response.data) {
                setTeachers(response.data);
                setShowTeacherResults(true);
            } else if (Array.isArray(response)) {
                setTeachers(response);
                setShowTeacherResults(true);
            }
        } catch (error) {
            
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files && e.target.files.length > 0 ? e.target.files[0] : null;
        if (file) {
            const maxSize = 20 * 1024 * 1024; // 20MB
            if (file.size && file.size > maxSize) {
                toastHelper.error('يجب أن يكون حجم الصورة أقل من 20MB');
                return;
            }

            const allowedExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.ico', '.heic'];
            const fileName = (file.name || '').toLowerCase();
            const hasValidExt = allowedExtensions.some(ext => fileName.endsWith(ext));

            if (!hasValidExt) {
                toastHelper.error('امتداد الملف غير صالح. المسموح: ' + allowedExtensions.join(', '));
                return;
            }

            setFormData(prev => ({ ...prev, Image: file }));
            setPreviewImage(URL.createObjectURL(file));
        } else {
            setFormData(prev => ({ ...prev, Image: null }));
            setPreviewImage(null);
        }
    };

    const handleTeacherSelect = (teacher) => {
        setSelectedTeacher(teacher);
        setSearchTerm(teacher.name);
        setShowTeacherResults(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedTeacher) {
            return toastHelper.error('الرجاء تحديد المدرس');
        }

        if (!formData.material_id) {
            return toastHelper.error('الرجاء تحديد المادة');
        }

        if (!formData.user_class) {
            return toastHelper.error('الرجاء تحديد الصف الدراسي');
        }

        if (formData.number_of_students <= 0 && !formData.Image) {
            return toastHelper.error('الرجاء إدخال عدد صحيح للطلاب');
        }

        setLoading(true);
        try {
            const dataToSend = new FormData();
            dataToSend.append('TeacherId', String(selectedTeacher.id));
            dataToSend.append('MaterialId', String(formData.material_id));
            dataToSend.append('UserClass', String(formData.user_class));
            dataToSend.append('NumberOfStudents', formData.Image ? "0" : String(formData.number_of_students));

            if (formData.Image) {
                dataToSend.append('Image', formData.Image);
            }

            
            // In web, the 4th param timeout might not be natively supported based on the signature
            // But if ApiServices matches, it will receive 300000.
            const response = await ApiServices.post('User/CreateRandomStudent', dataToSend, true, 300000);

            // Notify user
            toastHelper.success(`تم إنشاء الطالب(الطلاب) العشوائيين بنجاح!`);

            // Reset
            setSelectedTeacher(null);
            setSearchTerm('');
            setFormData({
                material_id: '',
                user_class: '',
                number_of_students: 10,
                Image: null
            });
            setPreviewImage(null);

        } catch (error) {
            
            let errorMsg = 'فشل في إنشاء الطلاب العشوائيين';
            if (error?.msg) {
                errorMsg = error.msg;
            } else if (error?.message) {
                errorMsg = error.message;
            } else if (error?.errors) {
                if (typeof error.errors === 'string') {
                    errorMsg = error.errors;
                } else if (typeof error.errors === 'object') {
                    const firstKey = Object.keys(error.errors)[0];
                    if (firstKey && Array.isArray(error.errors[firstKey]) && error.errors[firstKey].length > 0) {
                        errorMsg = error.errors[firstKey][0];
                    } else if (firstKey) {
                        errorMsg = String(error.errors[firstKey]);
                    }
                }
            } else if (typeof error === 'string') {
                errorMsg = error;
            }
            toastHelper.error(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="seed-data-page">
            <div className="form-container">
                <header className="form-header">
                    <h1>توليد طلاب وهميين (Seed Data)</h1>
                </header>

                <form onSubmit={handleSubmit}>
                    <div className="form-grid">

                        <div className="input-group full-width" ref={teacherSearchRef}>
                            <label><FontAwesomeIcon icon={faChalkboardTeacher} /> المدرس *</label>
                            <div className="search-input-wrapper">
                                <FontAwesomeIcon icon={faSearch} className="search-icon" />
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        if (selectedTeacher && e.target.value !== selectedTeacher.name) {
                                            setSelectedTeacher(null);
                                        }
                                    }}
                                    onFocus={() => { if (teachers.length > 0) setShowTeacherResults(true); }}
                                    placeholder="ابحث عن المدرس..."
                                    className="search-input-with-icon"
                                    required={!selectedTeacher}
                                />
                            </div>
                            {showTeacherResults && (
                                <ul className="autocomplete-results">
                                    {teachers.length > 0 ? (
                                        teachers.map(teacher => (
                                            <li key={teacher.id} onClick={() => handleTeacherSelect(teacher)}>
                                                {teacher.name}
                                            </li>
                                        ))
                                    ) : (
                                        <li className="no-results">لم يتم العثور على مدرسين</li>
                                    )}
                                </ul>
                            )}
                            {selectedTeacher && (
                                <div className="selected-item-badge">
                                    تم اختيار المدرس: <strong>{selectedTeacher.name}</strong>
                                </div>
                            )}
                        </div>

                        <div className="input-group">
                            <label><FontAwesomeIcon icon={faBook} /> المادة *</label>
                            <select
                                value={formData.material_id}
                                onChange={(e) => setFormData({ ...formData, material_id: e.target.value })}
                                required
                            >
                                <option value="">-- اختر المادة --</option>
                                {materials.map(mat => (
                                    <option key={mat.id || mat.id} value={mat.id}>{mat.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="input-group">
                            <label><FontAwesomeIcon icon={faSchool} /> الصف الدراسي *</label>
                            <select
                                value={formData.user_class}
                                onChange={(e) => setFormData({ ...formData, user_class: e.target.value })}
                                required
                            >
                                <option value="">-- اختر الصف الدراسي --</option>
                                {userClasses.map(cls => (
                                    <option key={cls.id || cls.id} value={cls.id}>{cls.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="input-group full-width">
                            <label><FontAwesomeIcon icon={faImage} /> صورة الوجه (اختياري - يعالجها الذكاء الاصطناعي)</label>
                            <div className="icon-uploader-wrap">
                                <FileUploader
                                    id="student-image-up"
                                    accept="image/*"
                                    MaxFileSize={20}
                                    previewUrl={previewImage}
                                    onFileChange={handleFileChange}
                                    placeholder="صورة الطالب"
                                    subText="امتدادات: JPG, PNG, GIF ... بحد أقصى 20MB"
                                    buttonText="اختر صورة"
                                    changeButtonText="تغيير الصورة"
                                />
                            </div>
                            {formData.Image && (
                                <div className="info-text">عند إرفاق صورة، سيتم إنشاء <strong>طالب واحد فقط</strong>.</div>
                            )}
                        </div>

                        <div className={`input-group full-width ${formData.Image ? 'disabled-input' : ''}`}>
                            <label><FontAwesomeIcon icon={faUserPlus} /> عدد الطلاب المراد إنشاؤهم لكل صف *</label>
                            <input
                                type="number"
                                min="1"
                                value={formData.Image ? 0 : formData.number_of_students}
                                onChange={(e) => setFormData({ ...formData, number_of_students: parseInt(e.target.value) || 0 })}
                                placeholder="مثلاً: 10"
                                required={!formData.Image}
                                disabled={!!formData.Image}
                            />
                        </div>

                    </div>

                    <footer className="form-footer">
                        <button type="submit" className="submit-btn" disabled={loading || !selectedTeacher}>
                            {loading ? (
                                <>
                                    <MiniLoader size={20} color="#ffffff" variant="dots" />
                                    <span>جاري الإنشاء...</span>
                                </>
                            ) : (
                                <>
                                    <FontAwesomeIcon icon={faSave} />
                                    <span>إنشاء الطلاب العشوائيين</span>
                                </>
                            )}
                        </button>

                        {(formData.user_class && selectedTeacher && formData.material_id) ? (
                            <div className="summary-text" style={{ marginTop: '16px', color: '#059669', fontWeight: '700' }}>
                                إجمالي الطلاب المتوقع إنشاؤهم: {formData.Image ? 1 : formData.number_of_students}
                            </div>
                        ) : null}
                    </footer>
                </form>
            </div>

            <style>{`
                .seed-data-page { padding: 40px 20px; background: #f8fafc; min-height: 100vh; direction: rtl;   font-family: "Zain", sans-serif; }
                .form-container { max-width: 800px; margin: 0 auto; background: white; padding: 40px; border-radius: 24px; box-shadow: 0 10px 40px rgba(0,0,0,0.05); }
                .form-header { display: flex; align-items: center; gap: 20px; margin-bottom: 40px; border-bottom: 2px solid #f1f5f9; padding-bottom: 20px; }
                .back-btn { background: #f1f5f9; border: none; padding: 10px 20px; border-radius: 12px; cursor: pointer; color: #64748b; font-weight: 700; display: flex; align-items: center; gap: 10px; }
                .form-header h1 { margin: 0; font-size: 1.8rem; color: #1e293b; font-weight: 800; }

                .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 25px; }
                .full-width { grid-column: 1 / -1; }

                .input-group { position: relative; }
                .input-group label { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; font-weight: 700; color: #475569; font-size: 0.95rem; }
                .input-group input[type="text"], .input-group input[type="number"], .input-group select {
                    width: 100%; padding: 14px 18px; border: 2px solid #e2e8f0; border-radius: 12px; font-size: 1rem;
                      font-family: "Zain", sans-serif; outline: none; transition: border-color 0.2s; box-sizing: border-box;
                }
                .input-group input:focus, .input-group select:focus { border-color: #6366f1; }
                .disabled-input input { background: #f1f5f9; color: #94a3b8; cursor: not-allowed; }
                .info-text { margin-top: 10px; font-size: 0.85rem; color: #059669; font-weight: 700; background: #d1fae5; padding: 8px 14px; border-radius: 8px; text-align: center; }

                .search-input-wrapper { position: relative; }
                .search-icon { position: absolute; right: 18px; top: 50%; transform: translateY(-50%); color: #64748b; }
                .search-input-with-icon { padding-right: 45px !important; }

                .autocomplete-results {
                    position: absolute; top: 100%; left: 0; right: 0; background: white; border: 1px solid #e2e8f0;
                    border-radius: 12px; box-shadow: 0 10px 25px rgba(0,0,0,0.1); max-height: 250px; overflow-y: auto;
                    z-index: 10; margin: 8px 0 0; padding: 0; list-style: none;
                }
                .autocomplete-results li { padding: 14px 18px; cursor: pointer; border-bottom: 1px solid #f1f5f9; color: #334155; font-weight: 600; transition: background 0.2s; }
                .autocomplete-results li:last-child { border-bottom: none; }
                .autocomplete-results li:hover { background: #f8fafc; color: #6366f1; }
                .autocomplete-results li.no-results { color: #94a3b8; cursor: default; }
                .autocomplete-results li.no-results:hover { background: white; color: #94a3b8; }

                .selected-item-badge { margin-top: 10px; display: inline-block; background: #e0e7ff; color: #4338ca; padding: 6px 14px; border-radius: 20px; font-size: 0.85rem; font-weight: 600; }

                .form-footer { margin-top: 40px; padding-top: 30px; border-top: 2px solid #f1f5f9; display: flex; flex-direction: column; align-items: center; }
                .submit-btn { background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%); color: white; border: none; padding: 16px 60px;
                    border-radius: 15px; font-size: 1.1rem; font-weight: 700; cursor: pointer; display: flex; align-items: center;
                    gap: 12px; transition: all 0.3s; box-shadow: 0 10px 20px -5px rgba(99, 102, 241, 0.4);   font-family: "Zain", sans-serif; }
                .submit-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 15px 30px -5px rgba(99, 102, 241, 0.5); }
                .submit-btn:disabled { background: #94a3b8; box-shadow: none; cursor: not-allowed; transform: none; }

                @media (max-width: 768px) {
                    .seed-data-page { padding: 20px 10px; }
                    .form-container { padding: 20px; border-radius: 15px; }
                    .form-header { gap: 10px; margin-bottom: 25px; }
                    .form-header h1 { font-size: 1.4rem; }
                    .form-grid { grid-template-columns: 1fr; gap: 20px; }
                    .submit-btn { width: 100%; padding: 14px 20px; justify-content: center; }
                }
            `}</style>
        </div >
    );
};

export default SeedData;
